<aza-rws-profile-header titleTranslationKey="SUBSCRIPTIONS" (closed)="onClosed()"></aza-rws-profile-header>
<section class="aza-section aza-theme">
  <div class="profile-subscriptions aza-vertical-stack aza-section-content">
    <div class="profile-subscriptions-unsubscribe-container">
      <label class="aza-text aza-horizontal-stack">
        <input [(ngModel)]="subs.unsubscribe" type="checkbox"
          class="profile-subscriptions-unsubscribe-input-field" />
          <span class="pofile-subscriptions-unsubscribe-text" translate>DO_NOT_SEND_ANY_EMAIL</span>
        </label>
      </div>
      @if (!subs.unsubscribe) {
        <div class="profile-subscriptions-list-title">
          <span class="profile-subscriptions-list-title-text" translate>EMAIL_CAMPAIGN_SUBSCRIPTIONS</span>
        </div>
        @for (sub of subs.subscriptions; track sub.email_campaign_type_id + sub.email_campaign_type_name) {
          <div class="profile-subscription-item">
            <label class="aza-text aza-horizontal-stack">
              <input [(ngModel)]="sub.subscribed" type="checkbox"
                class="profile-subscription-item-input-field" />
                <span class="profile-subscription-item-name">{{sub.email_campaign_type_name}}</span>
              </label>
            </div>
          }
        }
        <section class="section-form-button aza-section aza-theme profile-control-actions-container">
          <div class="aza-section-content aza-section-colors profile-subscriptions-save-button-container">
            <button (click)="onSave()"
              class="aza-button aza-section-inverted-colors profile-subscriptions-save-button">
              <span class="profile-subscriptions-save-button-text" translate>SUBMIT</span>
            </button>
          </div>
        </section>
      </div>
    </section>
